import client from '../base-api';

const serviceURL = '/analytics';

const analyticsService = {

    // FINISHED COACHING
    getFinishedPrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/finished-coaching/private-coaching`, {params: filterData});
    },
    getFinishedAssistedLivingCoachingList(filterData: any) {
        return client.get(`${serviceURL}/finished-coaching/assisted-living-coaching`, {params: filterData});
    },

    // ACTIVE COACHING HISTORY
    getActiveCoachingHistoryAssistedLivingCoaching(filterData: any) {
        return client.get(`${serviceURL}/active-coaching-history/assisted-living-coaching`, {params: filterData});
    },

    // UNITS DONE BY EXTERN COACHES
    getUnitsDoneByExternalCoachesPerWeek(filterData: any) {
        return client.get(`${serviceURL}/units-done-by-external-coaches/week`, {params: filterData});
    },
    getUnitsDoneByExternalCoachesPerMonth(filterData: any) {
        return client.get(`${serviceURL}/units-done-by-external-coaches/month`, {params: filterData});
    },


    // ACCOUNTING
    getAccountingPrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/accounting/private-coaching`, {params: filterData});
    },
    getAccountingSocioTherapyCoachingList(filterData: any) {
        return client.get(`${serviceURL}/accounting/socio-therapy-coaching`, {params: filterData});
    },
    getAccountingAssistedLivingCoachingList(filterData: any) {
        return client.get(`${serviceURL}/accounting/assisted-living-coaching`, {params: filterData});
    },
    getAccountingPrivateLearningCoachingList(filterData: any) {
        return client.get(`${serviceURL}/accounting/private-learning-coaching`, {params: filterData});
    },

    // RETROSPECTIVE
    getRetrospectiveAssistedLivingCoachingList(filterData: any) {
        return client.get(`${serviceURL}/retrospective/assisted-living-coaching`, {params: filterData});
    },

    // TERMINATED
    getTerminatedPrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/terminated/private-coaching`, {params: filterData});
    },
}

export default analyticsService;